import { render, staticRenderFns } from "./BlogDescription.vue?vue&type=template&id=10a37172&"
import script from "./BlogDescription.vue?vue&type=script&lang=js&"
export * from "./BlogDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports